<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">日本がフランスのイノベーション・ルネッサンスから学べること</h1>	

                <span class="meta"> Posted in November 2023 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/french-innovation-renaissance_bw.jpg" alt="">
                </figure>
                
<p>日本におけるスタートアップ・エコシステムの構築という話題になると、私はフランスのイノベーション・ルネッサンスの話をするのが好きだ。</p>
<p>この話を聞いたことがある人もいるだろうが、日本がスタートアップ・ネーションというアジェンダを追求する上で、貴重なロードマップを提供してくれるからだ。</p>
<p>20年前、フランスはスタートアップやベンチャーキャピタルにとって荒涼とした風景だった。当時、フランスで起きていたイノベーションのほとんどは漸進的なものに限られており、しばしば既存の大企業の中でサイロ化されていた。アントレプレナー（起業家）という言葉はフランス語に由来するが、逆説的なことに、当時のフランスではアントレプレナーシップは普及していなかった。リスク資本は基本的に存在しなかった。聡明な若者はエリート大学に入学するよう説得され、その後、大企業でキャリアを積むことを期待された。フランスの文化的メンタリティはリスクを嫌うものだった。キャリアの安定が尊ばれ、失敗は汚名とされた。会社を興した少数の選ばれた人々にとって、社会はそのような人々が大企業への就職に成功しなかったと一般的に考えていた。不幸にも起業に失敗した者は、フランス銀行の財務記録に黒いチェックマークを付けられ、住宅ローンを組むことができなくなる。</p>
<p>同時に海の向こうのシリコンバレーでは、インターネット・スタートアップ・コミュニティが活況を呈していた。当時フランスの財務大臣だったドミニク・ストロスカーンは、シリコンバレーでこのドットコム革命を目の当たりにし、世界が変わりつつあることを認識した。彼はまた、フランスが競争力を失いかけていることにも気づいていた。フランスには、エア・リキード、ダノン、ロレアル、トタルといった多国籍大企業があったが、機敏で革新的な新興企業のエコシステムは存在しなかった。</p>
<p>DSKとその代理人たちは、基本的に4つの指針を掲げて、フランスに思い切った変革を実行に移そうとした：</p>
<p>1. アーリーステージの新興企業に対するリスクキャピタルの不足という当面の問題を解決する。</p>
<p>2. フランス国民全員の富の不平等を解消する。</p>
<p>3. フランスの個人投資家の保護</p>
<p>4. フランス人のメンタリティを、イノベーションとリスクテイクを受け入れるものに変える。</p>
<p></p>
<p>フランスで最も人気のあるスポーツ</p>
<p>フランスには古いジョークがあり、フランスで最も人気のあるスポーツは、サッカー、ラグビー、サイクリングよりも上位にランクされている。</p>
<p>この格言にベレー帽のヒントを得て、フランス政府は独創的な政策変更でイノベーションの変革を促進した。具体的には、ベンチャー・キャピタル・ファンドに投資すれば、投資家が大幅な減税を受けられるという斬新な優遇税制を導入したのである。FCPI（公共イノベーション・ファンド）およびFIP（地域投資ファンド）と呼ばれるこのプログラムにおける新しいクラスのベンチャーキャピタルファンドは、民間企業に投資する従来のクローズドエンド型ファンドと同じ枠組みで規制されたベンチャーキャピタルファンド事業体であった。</p>
<p>標準的な規制に加えて、政府は前述の目的を達成するために、これらの新しいファンド構造に対してさらにいくつかのガードレールを課した。第一に、ファンドのジェネラル・パートナーは、規制対象事業体として、運営するために金融当局の承認が必要となった。さらに、コンプライアンスや報告義務も課された。最後に、これらのVCファンドは、一定の革新基準を満たしたフランスの新興企業に資本のかなりの割合を投資し、設立から2～3年かけてこれを行うことが求められた。</p>
<p>投資家はその見返りとして、ファンドに投資した年の所得税または富裕税から比例控除を受けることになる。さらに、VCファンドの分配金で得たキャピタルゲインも、最低5年間保有すればすべて非課税となる。</p>
<p>リスクへの過剰な露出を防ぐための保護措置が講じられ、さらにこれらの税制優遇措置によって緩和されたため、フランス政府はフランス国民全員にアクセスを開放した。フランス人の考えでは、富裕層だけを優遇するような優遇措置は、フランスの中核的価値観である「平等」を満たすものではなかった。</p>
<p>このプログラムは、フランスのスタートアップ・エコシステムの構築において大成功を収めた。17年間で約200億ドルが個人の貯蓄からベンチャーキャピタルに振り向けられ、最初の目標は達成された。</p>
<p>さらに今日、フランスは36のハイテク・ユニコーン、数百の独立系ベンチャー・キャピタル・ファンドからなる健全なエコシステムを誇り、毎年ヨーロッパで最も多くの新興企業が融資を受けている。</p>
<p>おそらく最も重要なことは、起業家精神とリスクテイクに対するフランス人の態度が一変したことである。100万人以上のフランス人納税者が、公的イノベーション・ファンド・プログラムのおかげでスタートアップの成長の恩恵を受けている。フランス政府は、長期にわたって高い財務実績を上げる成長資産クラスへのアクセスをすべての人に認めることで、実質的にすべてのフランス国民が国のイノベーション・ルネッサンスを共有できるようにしたのである。</p>
<p>私はこのプログラムの成功を目の当たりにした。15年間、私はこのプログラムに積極的に参加した。しかし、フランスをスタートアップの国へと変貌させたこのプログラムの役割を知るにつれ、私は改心した。</p>
<p>私の意見では、フランスの公的イノベーション・ファンド・プログラムは、フランスのテック・ルネッサンスを触媒する最もインパクトのある要素である。さらに、フランス政府は、その野心を縮小することで、その栄誉に安住することはなかった。BPI（フランス投資銀行）からの追加資金や、ラ・フレンチ・テック（La FrenchTech）や最近ではTIBIのようなイニシアチブによって、その努力を倍加させた。</p>
<p>ちなみに、イギリスも同時期にEISやVCTといったフランスのリテールファンドの独自版を導入していた。どちらも国内の新興企業エコシステムを強化する上で同様の効果を発揮しており、特にEIS制度は顕著であった。</p>
<p>したがって、英国のサクセス・ストーリーも見習う価値があるが、リスクや失敗に対するフランスの歴史的に保守的な考え方がより日本に近いため、フランスの軌跡は日本にとってより刺激的かもしれない。</p>


              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>

